// src/pages/About.js
import React from 'react';

export default function About() {
  return <h1>About Page</h1>;
}
